

























































import { Component, Vue } from "vue-property-decorator";
import AppFooter from "@/components/AppFooter.vue";
import LogoRow from "@/components/LogoRow.vue";
import AuthLoginForm from "@/components/AuthLoginForm.vue";
import * as util from "@/util";
import { logout } from "@/domain/backend";
import { TokenValidation } from "../domain";

@Component({
  components: { LogoRow, AppFooter, AuthLoginForm }
})
export default class AuthLogin extends Vue {
  accessToken = "";
  loginError = "";
  companyError: { companyID: number; next: null | (() => Promise<void>) } = {
    companyID: 0,
    next: null
  };
  isLoading = false;

  get lang() {
    return this.$store.state.lang.data;
  }

  get currentUser() {
    return this.$store.state.currentUser;
  }

  async created() {
    if (!this.$route.query || !this.$route.query.accessToken) {
      return;
    }
    const tokenParts = this.$route.query.accessToken.toString().trim().split("?");
    if (tokenParts.length == 0) return;
    if (tokenParts[0].length < 5) return;
    this.isLoading = true;
    this.accessToken = tokenParts[0];
    if (this.currentUser) {
      await logout();
    }
    await this.loginWithAccessToken();
  }

  async cmdTokenContinue() {
    if (!this.companyError.companyID || !this.companyError.next) {
      this.loginError = this.lang.errorMsgRedirect;
    } else {
      this.isLoading = true;
      this.loginError = "";
      // Reset company ID to avoid showing the message again
      this.companyError.companyID = 0;
      try {
        await this.companyError.next();
      } catch (err) {
        util.log("Error validando token", err);
        this.loginError = (err as Error).message;
      }
    }
    this.isLoading = false;
  }

  async loginWithAccessToken() {
    this.isLoading = true;
    this.loginError = "";
    try {
      const loginResult = await this.$store.dispatch("loginWithToken", this.accessToken);
      const token = loginResult.tokenValidation as TokenValidation;
      if (!token.companyExists) {
        this.companyError = {
          companyID: token.companyID,
          next: loginResult.next
        };
      } else {
        await loginResult.next();
      }
    } catch (err) {
      util.log("Error validando token", err);
      this.loginError = (err as Error).message;
    }
    this.isLoading = false;
  }
}
